// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3tDph","rightAdornment":"Header_rightAdornment__1yBJU"};